import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  DataElement,
  SaveGridHeadersResponse, Template,
} from '@store/user/user.model';
import { Observable } from 'rxjs';
import { SearchMixpanelUtil } from '@root/search/search-mixpanel-util';
import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import { MixpanelService } from '@shared/services/mixpanel.service';
import { SidePanelTab, SidePanelView } from '@store/search-board/search-board.model';
import { selectSidePanelState } from '@store/search-board/search-board.selector';

@Injectable({
  providedIn: 'root'
})
export class CustomHeadersService {

  private sidePanelTabOpened: SidePanelTab;
  private readonly searchMixpanelUtil: SearchMixpanelUtil = new SearchMixpanelUtil(this.store$);

  constructor(private readonly httpClient: HttpClient,
              private readonly store$: Store<AppState>,
              private readonly mixpanelService: MixpanelService) {

    this.store$
      .pipe(
        select(selectSidePanelState)
      )
      .subscribe((sidePanelView: SidePanelView) => {
        this.sidePanelTabOpened = sidePanelView.sidePanelTabOpened;
      });
  }

  public getGridHeaders(): Observable<Template> {
    return this.httpClient.get<Template>('/api/customize-table');
  }

  public saveGridHeaders(data: Array<DataElement>): Observable<SaveGridHeadersResponse> {
    this.logMixPanel('Search - Customize List Display Click - Grid', data);
    return this.httpClient
      .post<SaveGridHeadersResponse>('/api/save-updated-grid-list', data);
  }

  public getCardsAttributes(): Observable<Template> {
    return this.httpClient.get<Template>('/api/customize-card');
  }

  public saveCardsAttributes(data: Array<DataElement>): Observable<SaveGridHeadersResponse> {
    this.logMixPanel('Search - Customize List Display Click - Cards', data);
    return this.httpClient
      .post<SaveGridHeadersResponse>('/api/save-updated-card-list', data);
  }

  private logMixPanel(eventId: string, data: Array<DataElement>) {
    const columns: Array<string> = new Array<string>();

    data.forEach((dataElement) => {
      columns.push(dataElement.label);
    });

    this.searchMixpanelUtil.setupMixPanelItems(this.sidePanelTabOpened);

    this.mixpanelService.track(eventId, {
      countyList: this.searchMixpanelUtil.countyList,
      searchType: this.sidePanelTabOpened,
      isSavedSearch: (this.sidePanelTabOpened === 'quickSearch') ? false :
        this.searchMixpanelUtil.selectedSearch !== 'My Search Default',
      searchParameters: this.searchMixpanelUtil.searchFieldNames.join('; '),
      numberOfResults: this.searchMixpanelUtil.totalSearchRecords,
      selectedColumns: columns.join(', ')
    });
  }
}
